export const CURRENT_AFFAIRS = 'currentAffairs';
export const PDF = 'pdf';
export const VIDEO = 'video';
export const MATERIAL = 'material';
export const EPUB = 'epub';
export const TEST_SERIES = 'test';
export const COURSE_MATERIAL= 'courseMaterial';
export const LIBRARY_MATERIAL = 'libraryTopics';
export const ARTICLES = 'articles'


//screen names 
export const CURRENT_AFFAIRS_SCREEN_NAME = 'CurrentAffairs';
export const SHOW_CONTENT_SCREEN = 'ShowContentScreen';
export const TEST_DETAILS_SCREEN = 'TestDetails';
export const LESSON_PLANNER_SCREEN = 'lessonPlanner';
export const LESSON_CONTENT_SCREEN = 'courseMaterial';
export const TOPIC_LIBRARY_SCREEN = 'topicLibraryBooks';
export const CONTENT_LIBRARY_BOOKS = 'contentLibraryScreen';

// export const TEST_LIST_SCREEN = 'TestSeriesTestList';

